import { createI18n } from 'vue-i18n'

const messages = {}
const requireLocales = require.context('./locales', true, /\.json$/)

requireLocales.keys().forEach(filename => {
  const locale = filename.replace('./', '').replace('.json', '')
  messages[locale] = requireLocales(filename).default
})

const i18n = createI18n({
  legacy: false,
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages
})

export default i18n